import { bem } from '@socialive/common';
import PropTypes from 'prop-types';
import Tooltip from '../../Atoms/Tooltip';
import DirectorIcon from '../../Icons/DirectorIcon';
import MicOffIcon from '../../Icons/MicOffIcon';
import StartRecordingIcon from '../../Icons/StartRecordingIcon';
import './guestUserInfo.css';

/*
#tailwind
*/

function GuestUserInfo({ name, isDirector, isMuted, isRecording, isHostUser, testId, className, ...other }) {
  const nameTestId = testId && `${testId}-name`;

  return (
    <div className={bem`guestUserInfo ${className}`} {...other} data-testid={testId}>
      {isMuted && (
        <Tooltip content={<div className="guestUserInfo__tooltipContent">Mic Muted</div>}>
          <MicOffIcon className="guestUserInfo__micIcon" />
        </Tooltip>
      )}
      <Tooltip className="truncate" content={<div className="guestUserInfo__tooltipContent">{name}</div>}>
        <div className="guestUserInfo__name" data-testid={nameTestId}>{`${name}${isHostUser ? ' (host)' : ''}`}</div>
      </Tooltip>
      {isDirector && (
        <Tooltip content={<div className="guestUserInfo__tooltipContent">Director</div>}>
          <DirectorIcon />
        </Tooltip>
      )}
      {isRecording && (
        <Tooltip content={<div className="guestUserInfo__tooltipContent">Now Recording</div>}>
          <StartRecordingIcon />
        </Tooltip>
      )}
    </div>
  );
}

GuestUserInfo.propTypes = {
  name: PropTypes.string,
  isDirector: PropTypes.bool,
  isMuted: PropTypes.bool,
  isRecording: PropTypes.bool,
  isHostUser: PropTypes.bool,
  testId: PropTypes.string,
  className: PropTypes.string,
};

GuestUserInfo.defaultProps = {
  name: undefined,
  isDirector: false,
  isMuted: false,
  isRecording: false,
  isHostUser: false,
  testId: undefined,
  className: undefined,
};

export default GuestUserInfo;
